/**
 * Online API
 * # Summary Elisa B2B Online API written in golang hosted in AWS cloud  # Usage This API is used in the `https://yrityksille.elisa.fi/` pages.  # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountWithSubscriptions } from './accountWithSubscriptions.js';


/**
 * Response object for online API when multiple accounts are found for the msisdn.
 */
export interface SubscriptionSearchConflictResponse { 
    /**
     * Type of the conflict, in this case MULTIPLE_ACCOUNTS_FOUND_FOR_MSISDN.
     */
    type: SubscriptionSearchConflictResponse.TypeEnum;
    /**
     * List of account and subscription details associated with the msisdn. The type should be MULTIPLE_ACCOUNTS_FOUND to have this field populated.
     */
    items?: Array<AccountWithSubscriptions>;
}
export namespace SubscriptionSearchConflictResponse {
    export type TypeEnum = 'MULTIPLE_ACCOUNTS_FOUND' | 'NO_ACCOUNT_FOUND' | 'DUPLICATE_CONTACTS_FOUND';
    export const TypeEnum = {
        MULTIPLE_ACCOUNTS_FOUND: 'MULTIPLE_ACCOUNTS_FOUND' as TypeEnum,
        NO_ACCOUNT_FOUND: 'NO_ACCOUNT_FOUND' as TypeEnum,
        DUPLICATE_CONTACTS_FOUND: 'DUPLICATE_CONTACTS_FOUND' as TypeEnum
    };
}


